import { Job } from '../../../entities/job/job';
import { SystemWorkOrderStatus } from '../../../entities/job/system.workorder.status';

/**
 * Job status is stage-derived and only ever carries the FAMILY: a fully-cancelled job rolls up as
 * Closed (the Closed family is {Closed, Cancelled}), so the closed-or-cancelled check is a single
 * status comparison at job level.
 */
export function jobIsClosedOrCancelled(job?: Job): boolean {

    return job?.status === SystemWorkOrderStatus.Closed;
}

export function jobIsCompletedOrLater(job?: Job): boolean {

    return job?.status === SystemWorkOrderStatus.Completed || job?.status === SystemWorkOrderStatus.Finalised || !!job?.completedDate || !!job?.finalisedDate;
}

export function jobIsFinalised(job?: Job): boolean {

    return job?.status === SystemWorkOrderStatus.Finalised || !!job?.finalisedDate;
}
